// extracted by mini-css-extract-plugin
export var currentStep = "_il-2";
export var nodeCard = "_il-0";
export var pathHighlighted = "_il-1";